import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from './useMutation';

type CacheOption = 'invalidate' | 'reset';

export const useResetQueryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, { cacheResetOption: CacheOption }>({
    async mutationFn({ cacheResetOption }) {
      switch (cacheResetOption) {
        case 'invalidate':
          return queryClient.invalidateQueries();
        case 'reset':
          return queryClient.resetQueries();
      }
    },
  });
};
